import React from 'react';

const MediaFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="media-fill_svg__a"
                d="M9 7v-.06l2.768 1.655L9 10.582V7zM1 2h18V0h1v18h-1v-2H1v2H0V0h1v2zm0 3v1h2V5H1zm0 3.5v1h2v-1H1zM1 12v1h2v-1H1zm18-7h-2v1h2V5zm0 3.5h-2v1h2v-1zm0 3.5h-2v1h2v-1zm-11 .422l5.727-3.905L8 5.264v7.158z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 3)">
            <mask id="media-fill_svg__b" fill="#fff">
                <use xlinkHref="#media-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#media-fill_svg__a" />
            <g mask="url(#media-fill_svg__b)">
                <path fill="#000" d="M-2-3h24v24H-2z" />
            </g>
        </g>
    </svg>
);

MediaFillSvg.displayName = 'MediaFillSvg';
export default MediaFillSvg;
